import { render, staticRenderFns } from "./dialogPopup.vue?vue&type=template&id=815af9be&scoped=true&"
import script from "./dialogPopup.vue?vue&type=script&lang=js&"
export * from "./dialogPopup.vue?vue&type=script&lang=js&"
import style0 from "./dialogPopup.vue?vue&type=style&index=0&id=815af9be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815af9be",
  null
  
)

export default component.exports